import { Account, Transaction, FocusCard, HistoryItem, ReflectionType } from '@shared/types';

export const MOCK_ACCOUNTS: Account[] = [
  {
    id: 'acc_1',
    name: 'Primary Checking',
    balance: 1240.50,
    type: 'checking',
    institution: 'Chase',
  },
  {
    id: 'acc_2',
    name: 'Sapphire Preferred',
    balance: 4500.23, // Debt
    limit: 10000,
    type: 'credit',
    institution: 'Chase',
  },
  {
    id: 'acc_3',
    name: 'Student Loan A',
    balance: 12500.00,
    type: 'loan',
    institution: 'Navient',
  },
  {
    id: 'acc_4',
    name: 'High Yield Savings',
    balance: 8500.00,
    type: 'savings',
    institution: 'Ally',
  }
];

// Generate 30 days of transactions
const MERCHANTS = ['Target', 'Uber Eats', 'Netflix', 'Shell', 'Whole Foods', 'Amazon', 'Starbucks', 'Apple', 'Gym Shark', 'Delta Airlines'];
const CATEGORIES = ['Shopping', 'Food', 'Subscription', 'Transport', 'Groceries', 'Shopping', 'Food', 'Tech', 'Shopping', 'Travel'];

export const MOCK_TRANSACTIONS: Transaction[] = Array.from({ length: 40 }, (_, i) => {
  const date = new Date();
  date.setDate(date.getDate() - Math.floor(i * 0.8)); // Spread over last ~30 days
  
  const randIndex = Math.floor(Math.random() * MERCHANTS.length);
  const amount = Math.random() * (i % 5 === 0 ? 300 : 50) + 10; // Every 5th is larger
  
  // Randomly assign some reflections for historical data
  let reflection: ReflectionType = null;
  if (i > 5) { // Leave recent ones empty for user interaction
      const r = Math.random();
      if (r > 0.6) reflection = 'needed';
      else if (r > 0.3) reflection = 'wanted';
      else reflection = 'regret';
  }

  return {
    id: `tx_${i}`,
    merchant: MERCHANTS[randIndex],
    category: CATEGORIES[randIndex],
    amount: parseFloat(amount.toFixed(2)),
    date: date.toISOString(),
    logoUrl: `https://picsum.photos/40/40?random=${i}`,
    reflection: reflection
  };
});

// INITIAL_HABITS removed as we now generate them in cardEngine.ts

export const MOCK_HISTORY: HistoryItem[] = Array.from({ length: 45 }, (_, i) => {
  const date = new Date();
  date.setDate(date.getDate() - (44 - i));
  const trend = i * 80; 
  const volatility = Math.sin(i * 0.5) * 400 + (Math.random() * 200 - 100);
  
  return {
    date: date.toISOString().split('T')[0],
    value: Math.round(-8000 + trend + volatility)
  };
});